import HeaderBottomIndicators from './HeaderBottomIndicators';

export default HeaderBottomIndicators;
